var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-user-shop-list" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "门店" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入门店名称", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchClick($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.shopName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "shopName", $$v)
                        },
                        expression: "searchForm.shopName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "姓名" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入客户昵称", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchClick($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.userNick,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "userNick", $$v)
                        },
                        expression: "searchForm.userNick",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "search-btn-item" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.handleSearchClick },
                      },
                      [
                        _c("i", { staticClass: "el-icon-search" }),
                        _vm._v(" 搜索\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      { attrs: { plain: "" }, on: { click: _vm.resetSearch } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divider-line" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-bottom": "12px",
              "text-align": "left",
              display: "flex",
              gap: "10px",
            },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.handleAdd },
              },
              [_vm._v("新增")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              "element-loading-text": "正在加载数据...",
              "element-loading-spinner": "el-icon-loading",
              "element-loading-background": "rgba(255, 255, 255, 0.8)",
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "shopTable",
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  "font-size": "14px",
                },
                attrs: {
                  data: _vm.shopList,
                  "header-cell-style": {
                    backgroundColor: "#e8eaed",
                    color: "#333",
                    fontWeight: "bold",
                  },
                  "cell-style": { paddingBottom: "6px", paddingTop: "6px" },
                  border: "",
                  "row-key": "rowId",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "操作", width: "80", fixed: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#f56c6c" },
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "userNick",
                    label: "名称",
                    "min-width": "160",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              scope.row.userNick || scope.row.userName || "-"
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "shopName",
                    label: "门店",
                    "min-width": "200",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(_vm._s(scope.row.shopName || "-"))]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "创建时间",
                    "min-width": "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(_vm._s(scope.row.createTime || "-"))]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增改补门店",
            visible: _vm.dialogVisible,
            width: "560px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "shopForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "userNick" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请选择人员", clearable: "" },
                      on: { focus: _vm.onUserSelect },
                      model: {
                        value: _vm.form.userNick,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "userNick", $$v)
                        },
                        expression: "form.userNick",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append", icon: "el-icon-user" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.onUserSelect($event)
                            },
                          },
                          slot: "append",
                        },
                        [_vm._v("选择人员")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "全部" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: true },
                      on: { change: _vm.handleIsAllChange },
                      model: {
                        value: _vm.form.isAll,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isAll", $$v)
                        },
                        expression: "form.isAll",
                      },
                    },
                    [_vm._v("全部")]
                  ),
                  _vm._v(" "),
                  _vm.form.isAll
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#909399",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("选择全部后无需选择门店")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.form.isAll
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "经销商", prop: "dealerCode" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择经销商",
                              filterable: "",
                              clearable: "",
                            },
                            on: { change: _vm.handleDealerChange },
                            model: {
                              value: _vm.form.dealerCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dealerCode", $$v)
                              },
                              expression: "form.dealerCode",
                            },
                          },
                          _vm._l(_vm.dealerList, function (dealer) {
                            return _c("el-option", {
                              key: dealer.code || dealer.name,
                              attrs: {
                                label: dealer.name,
                                value: dealer.code || dealer.name,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "门店", prop: "shopName" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择门店",
                              filterable: "",
                              clearable: "",
                            },
                            on: { change: _vm.handleShopChange },
                            model: {
                              value: _vm.form.shopCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "shopCode", $$v)
                              },
                              expression: "form.shopCode",
                            },
                          },
                          _vm._l(_vm.dealerShopList, function (shop) {
                            return _c("el-option", {
                              key: shop.shopNo,
                              attrs: {
                                label: shop.shopName,
                                value: shop.shopNo,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }